import { Card, CardHeader, CardPreview, Subtitle1 } from '@fluentui/react-components';
import { ShieldLockRegular } from '@fluentui/react-icons';

export const NotAuthorized = ({ text }: { text?: string }) => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#f5f7fa',
                padding: '1rem',
            }}
        >
            <Card
                style={{
                    maxWidth: '420px',
                    width: '100%',
                    padding: '2rem',
                    textAlign: 'center',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                    borderRadius: '16px',
                    background: 'white',
                }}
            >
                <CardPreview>
                    <ShieldLockRegular
                        style={{
                            fontSize: '48px',
                            color: '#b10e1e',
                            marginBottom: '1rem',
                        }}
                    />
                </CardPreview>

                <CardHeader
                    header={
                        <Subtitle1 as="h1" style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
                            Access Denied
                        </Subtitle1>
                    }
                />

                <p style={{ marginBottom: '1.5rem', color: '#444' }}>
                    {text ?? 'You do not have permission to access this page.'}
                </p>
            </Card>
        </div>
    );
};
